import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("circle", {
  cx: "12",
  cy: "19",
  r: "2"
}), React.createElement("path", {
  d: "M10 3h4v12h-4z"
})), 'PriorityHighOutlined');